﻿import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Company } from 'src/app/Models/company';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { Location } from '@angular/common';

@Component({
  selector: 'companies-add',
  templateUrl: './companies-add.component.html',
  styleUrls: ['./companies-add.component.scss']
})

export class CompaniesAddComponent {
  id: any;
  form: FormGroup;
  submitted: boolean;
  company: Company;
  submitButtonText: string = 'GENERAL.LABELS.CREATE';
  isEditing: boolean;
  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService,
    private messageService: MessageService, private location: Location) {
    this.id = this.activatedRoute.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: ['', Validators.required]
    });

    if (this.id) {
      this.isEditing = true;
      this.submitButtonText = 'GENERAL.LABELS.EDIT';
      this.apiService.get('api/company/' + this.id).subscribe((data: any) => {
        this.company = data.data;
        this.form = this.formBuilder.group({
          name: [this.company.name, Validators.required]
        });
      });

    }

  }

  get controls() { return this.form.controls; }

  back() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    let model: Company = this.form.value as Company;

    if (this.isEditing) {
      model.id = this.id;
      this.apiService.put('api/company', model).subscribe((response: any) => {
        this.messageService.success("Éxito", "La compañia se ha actualizado exitosamente.");
        this.back();
      });
    }
    else {
      this.apiService.post('api/company', model).subscribe(() => {
        this.messageService.success("Éxito", "La compañia se ha agregado exitosamente.");
        this.back();
      });
    }
  }
}
